<script>
// globalSettings.js
import { ref, reactive, provide, inject } from 'vue'
import axios from 'axios'

const createGlobalSettings = () => {
  const siteSettings = reactive({})
  let isLoading = ref(false)

  const loadSettings = async () => {
    if (isLoading.value) return
    isLoading.value = true
    
    try {
      const response = await axios.get('/settings/api/active/')
      Object.assign(siteSettings, response.data)
    } catch (error) {
      console.error('Ошибка при загрузке настроек:', error)
    } finally {
      isLoading.value = false
    }
  }

  return {
    siteSettings,
    loadSettings
  }
}

export const useGlobalSettings = () => {
  return inject('globalSettings')
}

export const provideGlobalSettings = () => {
  const siteSettings = createGlobalSettings()
  provide('globalSettings', siteSettings)
  return siteSettings
}

export default {
  useGlobalSettings,
  provideGlobalSettings
}


</script>